export const CHARATERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
export const NAME_REGEX = /^[A-Za-z\s]+$/;
export const PHONE_REGEX = /^(\+|00)92\d{10}$|^\d{11}$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const IS_REGISTRATION_OPEN = false;